<div class="content">
    <div class="row items-push">
        <div class="col-sm-12 text-left">
            <ol class="breadcrumb push-10-t">
                <li><a [routerLink]="['/']">Inicio</a></li>
                <li><a class="link-effect" [routerLink]="['/passt/seguimiento']"
                    >PASST</a></li>
                <li><span class="link-effect">Rótulo</span></li>
            </ol>
        </div>
    </div>
  </div>

  <div class="content">
    <div class="block">
        <div class="block-header">
            <h3 class="block-title">Rótulo PASST</h3>
        </div>
        <form #modelForm="ngForm" (ngSubmit)="onSubmit(modelForm)" appIdentityRevealed>
        <div class="block-content">
            <div class="form-horizontal">
                <div class="form-group">
                  <label class="col-md-2 control-label">Año:</label>
                  <div class="col-md-4">
                    <mat-form-field appearance="outline">
                        <mat-label>
                            Año
                        </mat-label>
                        <input matInput type="text" placeholder="Anio" maxlength="200"
                            name="anio"
                            [(ngModel)]="model.anio" disabled />
                      </mat-form-field>             
                  </div>   
                  <label class="col-md-2 control-label">Sede:</label>
                  <div class="col-md-4">
                    <mat-form-field appearance="outline">
                      <mat-label>Sede</mat-label>
                      <input matInput type="text" placeholder="Sede" maxlength="200"
                            name="nombreSede"
                            [(ngModel)]="model.nombreSede" disabled/>
                      </mat-form-field>             
                  </div>            
              </div>
                <div class="form-group">
                    <label class="col-md-2 control-label">Título (*):</label>
                    <div class="col-md-10">
                      <mat-form-field appearance="outline" hideRequiredMarker>
                        <mat-label>Título</mat-label>
                        <input matInput type="text" placeholder="Sede" maxlength="200"
                            name="titulo"
                            [(ngModel)]="model.titulo" [disabled]="!model.editable" />
                      </mat-form-field>                
                    </div> 
                </div>   
                <div class="form-group">
                  <label class="col-md-2 control-label">Razón Social (*):</label>
                  <div class="col-md-4">
                    <mat-form-field appearance="outline">
                        <mat-label>
                            Razón Social
                        </mat-label>
                        <input matInput type="text" placeholder="Razón Social" maxlength="200"
                            name="razonSocial"
                            [(ngModel)]="model.razonSocial" [disabled]="!model.editable" />
                      </mat-form-field>             
                  </div>   
                  <label class="col-md-2 control-label">RUC:</label>
                  <div class="col-md-4">
                    <mat-form-field appearance="outline">
                        <mat-label>
                          RUC
                        </mat-label>
                        <input matInput type="text" placeholder="RUC" maxlength="13" appTwoDigitDecimaNumber
                            name="rUC"
                            [(ngModel)]="model.ruc" [disabled]="!model.editable" />
                      </mat-form-field>             
                  </div>            
              </div> 
              <div class="form-group">
                <label class="col-md-2 control-label">Dirección (*):</label>
                <div class="col-md-4">
                  <mat-form-field appearance="outline">
                      <mat-label>
                        Dirección
                      </mat-label>
                      <input matInput type="text" placeholder="Dirección" maxlength="200"
                          name="direccion"
                          [(ngModel)]="model.direccion" [disabled]="!model.editable" />
                    </mat-form-field>             
                </div>   
                <label class="col-md-2 control-label">Actividad Económica:</label>
                <div class="col-md-4">
                  <mat-form-field appearance="outline">
                      <mat-label>
                        Actividad Económica
                      </mat-label>
                      <input matInput type="text" placeholder="Actividad Económica" maxlength="200"
                          name="actividadEconomica"
                          [(ngModel)]="model.actividadEconomica" [disabled]="!model.editable" />
                    </mat-form-field>             
                </div>            
            </div>
            <div class="form-group">
              <label class="col-md-2 control-label">N° de Trabajadores (*):</label>
              <div class="col-md-4">
                <mat-form-field appearance="outline">
                    <mat-label>
                        N° de Trabajadores
                    </mat-label>
                    <input matInput type="text" placeholder="N° de Trabajadores" maxlength="4" appTwoDigitDecimaNumber
                        name="nroTrabajadores"
                        [(ngModel)]="model.nroTrabajadores" [disabled]="!model.editable" />
                  </mat-form-field>             
              </div>   
              <label class="col-md-2 control-label">Aprobado Por:</label>
              <div class="col-md-4">
                <mat-form-field appearance="outline">
                    <mat-label>
                        Aprobado Por
                    </mat-label>
                    <input matInput type="text" placeholder="Aprobado Por" maxlength="200"
                        name="aprobadoPor"
                        [(ngModel)]="model.aprobadoPor" [disabled]="!model.editable" />
                  </mat-form-field>             
              </div>            
          </div>
          <div class="form-group">
            <label class="col-md-2 control-label">Fecha Aprobación (*):</label>
            <div class="col-md-4"> 
                <mat-form-field appearance="outline">
                    <mat-label>Fecha Aprobación</mat-label>
                    <input
                      matInput
                      [matDatepicker]="pckrfechaAprobacion"
                      [(ngModel)]="model.fechaAprobacion"
                      id="fechaAprobacion"
                      name="fechaAprobacion"
                      required [disabled]="!model.editable"
                    />
                    <mat-datepicker-toggle
                      matSuffix
                      [for]="pckrfechaAprobacion"
                    ></mat-datepicker-toggle>
                    <mat-datepicker #pckrfechaAprobacion></mat-datepicker>
                    </mat-form-field>            
            </div>   
            <label class="col-md-2 control-label">Fecha Actualización:</label>
            <div class="col-md-4"> 
                <mat-form-field appearance="outline">
                    <mat-label>Fecha Actualización</mat-label>
                    <input
                      matInput
                      [matDatepicker]="pckrfechaActualizacion"
                      [(ngModel)]="model.fechaActualizacion"
                      id="fechaActualizacion"
                      name="fechaActualizacion"
                      required [disabled]="!model.editable"
                    />
                    <mat-datepicker-toggle
                      matSuffix
                      [for]="pckrfechaActualizacion"
                    ></mat-datepicker-toggle>
                    <mat-datepicker #pckrfechaActualizacion></mat-datepicker>
                    </mat-form-field>             
            </div>            
        </div>
        <div class="form-group">
          <label class="col-md-2 control-label">Objetivo (*):</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline">
                <mat-label>
                    Objetivo
                </mat-label>
                <input matInput type="text" placeholder="Objetivo" maxlength="2000"
                    name="objetivo"
                    [(ngModel)]="model.objetivo" [disabled]="!model.editable" />
              </mat-form-field>             
          </div>   
          <label class="col-md-2 control-label">Meta (*):</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline">
                <mat-label>
                    Meta
                </mat-label>
                <input matInput type="text" placeholder="Meta" maxlength="2000"
                    name="meta"
                    [(ngModel)]="model.meta" [disabled]="!model.editable" />
              </mat-form-field>             
          </div>            
      </div>
            </div>
        </div>
        <div class="block-content">
            <div class="form-horizontal">
                <mat-divider class="engie-divider"></mat-divider>
            </div>
            <mat-tab-group >
                <mat-tab label="Objetivos Especificos">
                  <div class="form-horizontal">
                    <div class="form-group">
                      <div class="col-sm-12 text-right">
                        <button type="button" class="btn btn-new" *ngIf="model.editable" mat-raised-button (click)="openDialogAccion()" ><mat-icon>description</mat-icon> Agregar Objetivo</button>
                        
                      </div>
                    </div>
                  </div>
                    <div class="table-responsive">
                        <table mat-table [dataSource]="model.objetivos" class="table table-striped table-vcenter">
                          <ng-container matColumnDef="objetivo">
                            <th mat-header-cell *matHeaderCellDef>Objetivo</th>
                            <td mat-cell *matCellDef="let element">{{ element.objetivo }}</td>
                          </ng-container>
                    
                          <ng-container matColumnDef="meta">
                            <th mat-header-cell *matHeaderCellDef>Meta</th>        
                            <td mat-cell *matCellDef="let element">{{ element.meta }}</td>
                          </ng-container>

                          <ng-container matColumnDef="indicador">
                            <th mat-header-cell *matHeaderCellDef>Indicador</th>        
                            <td mat-cell *matCellDef="let element">{{ element.indicador }}</td>
                          </ng-container>

                          <ng-container matColumnDef="presupuesto">
                            <th mat-header-cell *matHeaderCellDef>Presupuesto</th>        
                            <td mat-cell *matCellDef="let element">{{ element.presupuesto }}</td>
                          </ng-container>

                          <ng-container matColumnDef="recurso">
                            <th mat-header-cell *matHeaderCellDef>Recurso</th>        
                            <td mat-cell *matCellDef="let element">{{ element.recurso }}</td>
                          </ng-container>
        
                    
                          <ng-container matColumnDef="acciones">
                            <th mat-header-cell *matHeaderCellDef>Acciones</th>
                            <td mat-cell *matCellDef="let element"> 
                              <button type="button" *ngIf="model.editable" mat-icon-button color="primary" (click)="openDialogAccion(element)" aria-label="Editar">
                                <mat-icon>create</mat-icon>
                              </button>
                              <button type="button" *ngIf="model.editable" mat-icon-button color="primary" (click)="eliminarObjetivo(element)" aria-label="Eliminar">
                                <mat-icon>delete</mat-icon>
                              </button>
                            </td>
                          </ng-container>
                    
                          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                        </table>
            
                      </div>  
                </mat-tab>
            </mat-tab-group>
        </div>
        <div class="block-content">
          <div class="form-horizontal pad-25">
              <div class="form-group">
                  <div class="col-sm-12 text-right">
  
                    <button type="submit" class="btn btn-naranja" mat-raised-button><mat-icon>save</mat-icon> Guardar</button>
                    <a class="btn btn-naranja2" mat-raised-button (click)="closed()" ><mat-icon>exit_to_app</mat-icon> Salir</a>
                  </div>
              </div>
          </div>
        </div>
      </form>
    </div>
  </div>